module.exports = __webpack_public_path__ + "img/banner-torneo.3580d600.jpg";